const Style = {

  base: 'relative clear-both border-0 p-0 last:mb-0',
  error: `border-0 pt-6 pl-4 pr-4 mb-4 before:absolute before:left-0 before:right-0 
    before:top-0 before:bottom-2 before:rounded-control before:border before:border-solid before:border-sg-red`,
  errorMessage: 'clear-both top-0 -ml-4 -mr-4 mb-0',

}

export default Style;